const Colors={
    lightGreen:'#d7fada',
    lightRed:'#ffdede'
}

export default Colors;